import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {AppState } from 'src/app/core/models/app-state.models';
import { sessionSelectors } from 'src/app/store/selectors';

@Component({
    selector: 'doc-form-checkbox-multi',
    templateUrl: 'checkbox-multi.component.html',
    styleUrls: ['checkbox-multi.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DocCheckboxMultiComponent),
            multi: true
        }
    ]
})

export class DocCheckboxMultiComponent implements OnInit, ControlValueAccessor {
    private onDestroyed$ = new Subject();
  

    @Input() parentForm: UntypedFormGroup;
    @Input() controlName: string;
    @Input() label = '';
    @Input() boldLabel = false;

    @Input() placeholder = '';
    @Input() maxRows = 3;
    @Input() minRows = 2;
    @Input() autoResize = true;
    @Input() addOtherOption = false;

    value: string = '';
    changed = (value: any) => { };
    touched = () => { };
    disabled: boolean;

    checkedValues = {}

    acceptOther = false;
    otherValue = '';

    constructor(
        private store: Store<AppState>
    ) {
        
    }

    ngOnInit() {
        // this.options.push(otherOption)
    }

    /* getValue(option: CheckboxOption | ConsultationAnsOption) {
        if (option.hasOwnProperty('value')) {
            return option['value'];
        } else if (option.hasOwnProperty(this.lang)) {
            return option[this.lang]
        } else {
            return ''
        }
    }
 */
    /* getName(option: CheckboxOption | ConsultationAnsOption) {
        if (option.hasOwnProperty('name')) {
            return option['name'];
        } else if (option.hasOwnProperty(this.lang)) {
            return option[this.lang]
        } else {
            return ''
        }
    } */

   /*  isChecked(option: CheckboxOption | ConsultationAnsOption) {
        if (this.checkedValues.hasOwnProperty(this.getValue(option))) {
            return true;
        } else {
            return false
        }
    } */

    writeValue(value: any): void {
        if (Array.isArray(value)) {
            value.forEach(v => {
                this.checkedValues[v] = v;
            });
        } else {
            this.value = ''
        }

        /* this.checkOtherOption(); */
    }
    registerOnChange(fn: any): void {
        this.changed = fn;
    }
    registerOnTouched(fn: any): void {
        this.touched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    changedStatus(event: MatCheckboxChange) {
        if (event.checked) {
            this.checkedValues[event.source.value] = event.source.value;
        } else {
            delete this.checkedValues[event.source.value];
        }
        this.changed(this.getCheckedOptions());
        this.touched();
    }

    otherOptionStatus(event: MatCheckboxChange) {
        if (event.checked) {
            this.acceptOther = true;
        } else {
            this.acceptOther = false;
        }
    }

    private getCheckedOptions(): string[] {
        return Object.values(this.checkedValues);
    }

    otherOption(e) {
        this.checkedValues['other'] = e;
        this.changed(this.getCheckedOptions());
        this.touched();
    }

   /*  checkOtherOption() {
        const optionsValue = this.getCheckedOptions();
        for (let i = 0; i < optionsValue.length; i++) {
            let found = false;
            for (let j = 0; j < this.options.length; j++) {
                if (this.getValue(this.options[j]) === optionsValue[i]) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                this.checkedValues['other'] = optionsValue[i];
                delete this.checkedValues[optionsValue[i]]
                this.acceptOther = true;
                this.otherValue = optionsValue[i];
                return;
            }
        }
    } */
}

interface CheckboxOption {
    name?: string,
    value?: string
}